import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import { useLabels } from 'wsm-common-data';

import FacetTitle from './FacetTitle';
import FacetGroup from './FacetGroup';
import { FACET_OVERRIDE_TYPE_SELECT } from '../global-constants';

const MultiFacetGroup = ({
	facets,
	groupId,
	groupTitleLabel,
	openDetailsModal,
	detailsLinkData,
	collapsed
}) => {
	const [isCollapsed, setCollapsed] = useState(collapsed);

	const handleCollapse = () => {
		setCollapsed(!isCollapsed);
	};

	const expandIcon = isCollapsed ? 'ddc-icon-expand' : 'ddc-icon-collapse';

	const labels = useLabels();
	const facetTitle = labels.get(groupTitleLabel);

	const hasContentOrLabel =
		detailsLinkData &&
		(detailsLinkData.mainDetail ||
			detailsLinkData.subContent?.length !== 0);
	return (
		<Panel
			className="facet-list-group"
			id={groupId}
			onToggle={handleCollapse}
			expanded={!isCollapsed}
			data-facet-group={groupId}
			role="tablist"
		>
			<Panel.Heading>
				<Panel.Title toggle>
					<FacetTitle {...{ facetTitle, expandIcon }} />
				</Panel.Title>
			</Panel.Heading>
			<Panel.Body collapsible>
				{(facets || []).map(({ facet, facetSelections }) => (
					<FacetGroup
						facet={facet}
						selectedValues={
							facetSelections ? facetSelections.values : []
						}
						renderPanel={false}
						// TODO: This should be configurable per group/facet
						overrideType={FACET_OVERRIDE_TYPE_SELECT}
						key={`facetgroup-${facet.id}`}
					/>
				))}
				{hasContentOrLabel && (
					<button
						type="button"
						className="text-link mt-3 text-decoration-underline text-link-muted text-left"
						onClick={() =>
							openDetailsModal(facetTitle, detailsLinkData, true)
						}
					>
						<span className="ddc-font-size-xsmall">
							{labels.get('ABOUT')} {facetTitle}
						</span>
					</button>
				)}
			</Panel.Body>
		</Panel>
	);
};

MultiFacetGroup.propTypes = {
	facets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	groupId: PropTypes.string.isRequired,
	groupTitleLabel: PropTypes.string.isRequired,
	collapsed: PropTypes.bool.isRequired,
	openDetailsModal: PropTypes.func,
	detailsLinkData: PropTypes.shape({
		mainDetail: PropTypes.string,
		subContent: PropTypes.shape([])
	})
};

export default MultiFacetGroup;
